<template>
  <div>
    <h3>Types</h3>
    <div class="icon-list">
      <div v-for="type in types" :key="type.id" class="amsom-button"
           @click="setSelectedTypeAndRedirectToNatures(type.id)">
        <button class="btn btn-info">
          <i :class="fontawesomeico(type.id)"></i>
        </button>
        <span class="amsom-button-libelle">{{ type.libelle }}</span>

      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "Types",
  data() {
    return {
      selectedSollicitation: null,
    }
  },
  computed: {
    ...mapGetters('types', ['iCanWrite']),
    ...mapGetters('categories', ['selectedCategory']),
    types() {
      return this.iCanWrite.filter(type => type.categorie === this.selectedCategory)
    }
  },
  methods: {
    ...mapActions('types', ['setSelectedType']),
    ...mapActions('natures', ['setSelectedNature']),
    ...mapActions('motifs', ['setSelectedMotif']),
    ...mapActions('entrees', ['setSelectedEntree']),
    setSelectedTypeAndRedirectToNatures(typeID) {
      this.setSelectedType(typeID)
      this.$router.push({
        name: 'natures',
        params: {sollicitation: this.selectedSollicitation}
      });
    },
    fontawesomeico(ID) {
      if (ID === "AIR") return 'fas fa-democrat'
      if (ID === "ASC") return 'fas fa-arrows-alt-v'
      if (ID === "BAD") return 'fas fa-lock-open'
      if (ID === "CHE") return 'fas fa-thermometer-three-quarters'
      if (ID === "ELE") return 'fas fa-bolt'
      if (ID === "EV") return 'fab fa-pagelines'
      if (ID === "HUM") return 'fas fa-tint'
      if (ID === "INT") return 'fas fa-phone-square'
      if (ID === "MAC") return 'fas fa-drafting-compass'
      if (ID === "MEN") return 'fas fa-tree'
      if (ID === "OCC") return 'fas fa-low-vision'
      if (ID === "PLO") return 'fas fa-faucet'
      if (ID === "PPK") return 'fas fa-warehouse'
      if (ID === "SEC") return 'fas fa-shield-alt'
      if (ID === "SER") return 'fas fa-key'
      if (ID === "SOL") return 'fas fa-shoe-prints'
      if (ID === "TOI") return 'fas fa-home'
      if (ID === "TPI") return 'fas fa-ruler-combined'
      if (ID === "TRA") return 'fas fa-ruler-combined'
      if (ID === "TSE") return 'fas fa-ruler-combined'
      if (ID === "TV") return 'fas fa-tv'
      if (ID === "VEN") return 'fas fa-fan'
      if (ID === "VIT") return 'fab fa-windows'
      if (ID === "VPK") return 'fas fa-car'
      return 'fas fa-cog'
    }
  },
  // computed: {
  //   types() {
  //     // return JSON.parse(storeTypes.types).filter(type => type.categorie === storeCategories.selectedCategory)
  //     return actionsTypes.getMyType().filter(type => type.categorie === storeCategories.selectedCategory)
  //   }
  // },
  mounted: function () {
    if (typeof this.$route.params.sollicitation !== 'undefined' && this.$route.params.sollicitation !== null) {
      this.selectedSollicitation = this.$route.params.sollicitation
    }
    this.setSelectedType(null)
    this.setSelectedNature(null)
    this.setSelectedMotif(null)
    this.setSelectedEntree(null)

    // if (this.types.length === 1){
    //   this.setSelectedType(this.types[0].id)
    //   this.$router.push({
    //     name: 'natures',
    //     params: {sollicitation: this.selectedSollicitation}
    //   });
    // }
  }
}
</script>

<style scoped>

</style>